import { ElementRef, OnChanges, SimpleChanges, AfterViewInit, OnDestroy, } from "@angular/core";
import { DynamicComponentLoaderService } from "../../dynamic-component-loader/dynamic-component-loader.service";
import { isDefaultModel, defaultModel2UProperty as defaultModel2ViewModel, } from "src/app/dynamic-module/lib/mapper/defaultModel2UProperty";
import { PanelsService } from "../panels/panels.service";
import { resolveThemeCssClass, } from "src/app/dynamic-module/lib/public_api";
import { ScopedPanelCssService, } from "../../utils/scoped-panel-css.service";
var DynamicComponent = /** @class */ (function () {
    function DynamicComponent(dynamicComponentLoader, panelsService, hostRef, scopedPanelCssService) {
        this.dynamicComponentLoader = dynamicComponentLoader;
        this.panelsService = panelsService;
        this.hostRef = hostRef;
        this.scopedPanelCssService = scopedPanelCssService;
        this.data = null;
        this.scopedCssController = null;
        this.scopedCssHostClass = "";
        this.scopedCssPanelName = "";
        this.viewInitialized = false;
        this.rootClasses = "";
    }
    Object.defineProperty(DynamicComponent.prototype, "hostClasses", {
        get: function () {
            return [this.rootClasses, this.scopedCssHostClass]
                .filter(Boolean)
                .join(" ");
        },
        enumerable: true,
        configurable: true
    });
    DynamicComponent.prototype.ngOnChanges = function (changes) {
        if (changes.data) {
            this.prepareData();
            this.syncScopedCss();
        }
    };
    DynamicComponent.prototype.ngAfterViewInit = function () {
        this.viewInitialized = true;
        this.syncScopedCss();
    };
    DynamicComponent.prototype.ngOnDestroy = function () {
        this.destroyScopedCss();
    };
    DynamicComponent.prototype.prepareData = function () {
        if (!this.data || !this.data.contentTypeAlias)
            return;
        var dataMapper = this.dynamicComponentLoader.getDataMapperFor(this.data.contentTypeAlias);
        if (isDefaultModel(this.data)) {
            this.data = dataMapper
                ? dataMapper.map(this.data)
                : defaultModel2ViewModel(this.data);
        }
        this.applyTheme();
        this.panelsService.markAsLoaded({ data: this.data });
    };
    DynamicComponent.prototype.syncScopedCss = function () {
        if (!this.data || !this.data.contentTypeAlias) {
            this.destroyScopedCss();
            return;
        }
        if (this.scopedCssPanelName !== this.data.contentTypeAlias) {
            this.destroyScopedCss();
            this.scopedCssController = this.scopedPanelCssService.create(this.data.contentTypeAlias);
            this.scopedCssHostClass = this.scopedCssController.hostClass;
            this.scopedCssPanelName = this.data.contentTypeAlias;
        }
        if (!this.viewInitialized || !this.scopedCssController) {
            return;
        }
        this.scopedCssController.mount(this.hostRef.nativeElement);
        this.scopedCssController.update(this.getScopedCssValue());
    };
    DynamicComponent.prototype.destroyScopedCss = function () {
        if (this.scopedCssController) {
            this.scopedCssController.destroy();
        }
        this.scopedCssController = null;
        this.scopedCssHostClass = "";
        this.scopedCssPanelName = "";
    };
    DynamicComponent.prototype.getScopedCssValue = function () {
        if (this.data && this.data.customCss && this.data.customCss.value) {
            return this.data.customCss.value;
        }
        if (this.data && this.data.customCSS && this.data.customCSS.value) {
            return this.data.customCSS.value;
        }
        return "";
    };
    DynamicComponent.prototype.applyTheme = function () {
        var panelSettings = this.data && this.data.panelSettings ? this.data.panelSettings : null;
        var theme = panelSettings && panelSettings.theme && panelSettings.theme.value;
        if (theme) {
            this.rootClasses = resolveThemeCssClass(panelSettings);
            var themeValue = theme;
            for (var key in theme) {
                if (theme.hasOwnProperty(key)) {
                    this.hostRef.nativeElement.style.setProperty(this.toCSSVariableName(key), themeValue[key]);
                }
            }
        }
        else {
            this.rootClasses = "";
        }
    };
    DynamicComponent.prototype.toCSSVariableName = function (str) {
        return ("--" +
            str
                .split("")
                .map(function (letter, idx) {
                return letter.toUpperCase() === letter
                    ? "" + (idx !== 0 ? "-" : "") + letter.toLowerCase()
                    : letter;
            })
                .join(""));
    };
    return DynamicComponent;
}());
export { DynamicComponent };
